import Headspace from 'headspace';
import { loader } from '../utils/loader';

/**
 * Header
 */
class Header {
	/**
	 * Construct
	 *
	 * @description set state and cache elements.
	 *
	 * @param {DialogService} DialogService Dialog service.
	 */
	constructor(element) {
		this.element = element;
		this.config = {
			showAtBottom: false,
			classNames: {
				base: 'rx-header',
				fixed: 'rx-header--fixed',
				hidden: 'rx-header--hidden',
			},
		};

		this.init();
	}

	/**
	 * Init
	 *
	 * @description initialize.
	 */
	init() {
		Headspace(this.element, this.config);
	}
}

/**
 * Create Header
 */
export const createHeader = () => {
	loader('.rx-header', Header);
};
